/* eslint-disable max-len */
import React from "react"
import Icon from "@ant-design/icons"

const ThreePointsSvg = () => (
  <svg
    width="20"
    height="4"
    viewBox="0 0 20 4"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg">
    <circle cx="2" cy="2" r="2" fill="currentColor" />
    <circle cx="10" cy="2" r="2" fill="currentColor" />
    <circle cx="18" cy="2" r="2" fill="currentColor" />
  </svg>
)

const ThreePointsIcon = (props) => (
  <Icon component={ThreePointsSvg} {...props} />
)

export { ThreePointsIcon }
